import {
  AUEErrorMessages,
  isLoaded as isLoadedAUEErrorMessages,
  UnassignedAUEErrorMessages,
} from 'ApplicationEntry/models/AUEErrorMessages';
import {
  isLoaded as isLoadedLife70Messages,
  Life70ErrorMessages,
  UnassignedLife70ErrorMessages,
} from 'ApplicationEntry/models/Life70ErrorMessages';
import {Loaded} from 'Core/models/Async';
import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class UnvalidatedMessage {
  public readonly key = 'UnvalidatedMessage';

  constructor(
    public readonly aueErrorMessage: AUEErrorMessages,
    public readonly life70ErrorMessage: Life70ErrorMessages
  ) {}
}

export class InvalidMessage {
  public readonly key = 'InvalidMessage';

  constructor(
    public readonly aueErrorMessage: AUEErrorMessages,
    public readonly life70ErrorMessage: Life70ErrorMessages
  ) {}
}

type AppProps = {
  aueErrorMessage: AUEErrorMessages;
  life70ErrorMessage: Life70ErrorMessages;
};

export class ValidMessage {
  public static createFromApp({aueErrorMessage, life70ErrorMessage}: AppProps) {
    return this.create(aueErrorMessage, life70ErrorMessage);
  }

  public static create(aueErrorMessage: AUEErrorMessages, life70ErrorMessage: Life70ErrorMessages) {
    return isLoadedAUEErrorMessages(aueErrorMessage) && isLoadedLife70Messages(life70ErrorMessage)
      ? new ValidMessage(aueErrorMessage, life70ErrorMessage)
      : new InvalidMessage(aueErrorMessage, life70ErrorMessage);
  }

  public readonly key = 'ValidMessage';
  private constructor(
    public readonly aueErrorMessage: Loaded<object[]>,
    public readonly life70ErrorMessage: Loaded<object[]>
  ) {}
}

export type Messages = UnvalidatedMessage | InvalidMessage | ValidMessage;

export type MessagesOptions<TReturn> = ToPartialMatchOptions<Messages, 'key', TReturn>;

export const matchMessages = <TReturn>(options: MessagesOptions<TReturn>) => (app: Messages): TReturn => {
  switch (app.key) {
    case 'InvalidMessage':
      return options.InvalidMessage ? options.InvalidMessage(app) : options.default(app);
    case 'UnvalidatedMessage':
      return options.UnvalidatedMessage ? options.UnvalidatedMessage(app) : options.default(app);
    case 'ValidMessage':
      return options.ValidMessage ? options.ValidMessage(app) : options.default(app);
  }
};

export const changeAUEErrorMessages = (aueErrorMessages: AUEErrorMessages) => (app: Messages) =>
  ValidMessage.createFromApp({
    ...app,
    aueErrorMessage: aueErrorMessages,
  });

export const changeLife70ErrorMessages = (life70ErrorMessages: Life70ErrorMessages) => (app: Messages) =>
  ValidMessage.createFromApp({
    ...app,
    life70ErrorMessage: life70ErrorMessages,
  });

export const EmptyMessage = new UnvalidatedMessage(
  new UnassignedAUEErrorMessages(),
  new UnassignedLife70ErrorMessages()
);
